import Check from './InstantFunding.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const InstantFundingLogo = ({width = "165px", alt = "Green Check", ...props}: ImageProps) => <div {...props}><img src={Check} width={width} alt={alt} /></div>
export default InstantFundingLogo;
